<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <base-setting-widget :iteminfo="iteminfo" v-bind="$attrs" v-on="$listeners">
    <div class="w-full flex color-33">
      <span class="fs-14 w-100">组件位置：</span>
      <RadioGroup  class="flex w-full j-between" v-model="iteminfo.config.isFloat">
        <Radio :label="1">固定位置</Radio>
        <Radio :label="2">底部悬浮</Radio>
        <Radio :label="3">底部右侧悬浮</Radio>
      </RadioGroup>
    </div>

    <div class="fs-14 color-33 m-t-10">
      上传图片
    </div>

    <div v-if="iteminfo.config.isFloat===1 ||iteminfo.config.isFloat===2 " class="fs-12 color-99 m-v-10 m-t-10" style="margin-right: 0px">
      建议图片尺寸为1125*180px，图片格式为png或jpg，图片大小不超过2mb。
    </div>
    <div v-if="iteminfo.config.isFloat===3 "  class="fs-12 color-99 m-v-10 m-t-10" style="margin-right: 0px">
      图片格式为png或jpg，图片大小不超过2mb。
    </div>

    <div
      style="background-color: #F2F2F2;" class="w-full  p-10">
      <RatioDiv :radio-value="17"
      >
        <div style="position: absolute"
             @click="choicePic()"
             class="w-full h-full flex j-center">
          <div class="bg-white h-full flex-column"
               v-if="iteminfo.config.btBgImg===''"
               style="width: 100%">
            <Icon color="#cccccc" size="20" type="ios-add"/>
            <span style="font-size: 10px">上传图片</span>
          </div>
          <img v-if="iteminfo.config.btBgImg" :src="iteminfo.config.btBgImg" alt=""
               :style="{width: getBgImgWidth()}">
        </div>
      </RatioDiv>
    </div>

    <ul class="m-t-10">
      <li :key="index" class="m-b-10" style="background-color: #F2F2F2"
          v-for="(item,index) in iteminfo.config.datalist">
        <div class="flex p-10" style="min-height: 100px">
          <div class="flex flex-1" style="flex-direction: column">

            <div class="flex-column" style="height: 100%">
              <Input placeholder="电话号码" v-model:value="item.phone"></Input>
            </div>
          </div>

          <div class="flex-column a-center flex-s-0"
               style="width: 50px;justify-content: space-around;">
            <i :style="{color:getUpColor(index)}" @click.stop="onUpClick(index)"
               class="icon-up fs-18"
               style="cursor: pointer;"/>
            <i :style="{color:getDownColor(index,iteminfo.config.datalist.length)}"
               @click.stop="onDownClick(index)"
               class="icon-down fs-18"
               style="cursor: pointer;"/>
            <i @click.stop="onDelClick(index)" class="icon-delete_facet fs-18"
               style="cursor: pointer;color: #666666"/>
          </div>

        </div>

      </li>

      <li @click="onItemAddClick" class="flex a-center j-center m-v-10" key="abc"
          style="height: 48px;border:1px dashed #D8D8D8;cursor: pointer;background-color: #F2F2F2">
        <Icon size="24" type="ios-add"/>
        <div class="m-l-2">添加电话号码</div>
      </li>
    </ul>

    <div class="flex">
      <div class="color-33 fs-14 m-r-10 flex a-center">按钮名称:</div>
      <Input style="width: 200px" placeholder="按钮内容" v-model:value="iteminfo.config.btText"/>
    </div>

    <div class="flex m-t-10">
      <div class="color-33 fs-14  m-r-10 flex a-center">按钮背景:</div>
      <div class="border w-100 b-radius-3 flex a-center p-h-10" style="height: 32px">
        {{ iteminfo.config.btBgColor }}
      </div>
      <ColorPicker class="m-l-10 ld-color-pick" recommend
                   v-model="iteminfo.config.btBgColor"/>
    </div>

    <div class="flex m-t-10">
      <div class="color-33 fs-14  m-r-10 flex a-center">文字颜色:</div>
      <div class="border w-100 b-radius-3 flex a-center p-h-10" style="height: 32px">
        {{ iteminfo.config.btTextColor  }}
      </div>
      <ColorPicker class="m-l-10 ld-color-pick" recommend
                   v-model="iteminfo.config.btTextColor"/>
    </div>

    <pic-choice-widget
      ref="picChoiceWidget"
      :on-ok="picChoiceOk"
    />

  </base-setting-widget>
</template>

<script>
import BaseSettingWidget from '../base/BaseSettingWidget'
import UpLoadImage from '../../common/UpLoadImage'
import RatioDiv from '@/components/common/RatioDiv'
import PicChoiceWidget from '@/components/common/chiose/PicChoiceWidget'


export default {
  name: 'PhoneSettingWidget',
  components: {
    PicChoiceWidget,
    RatioDiv,
    BaseSettingWidget,
    UpLoadImage,
  },
  props: {
    iteminfo: Object
  },
  data () {
    return {
      showPicChoiceModal: false,
      clickedItem2ShowModal: 0,
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      // this.getDataList()
    },
    onItemAddClick () {
      this.iteminfo.config.datalist.push({
        id: 0,
        phone: '',
      })
    },
    onUpClick (index) {
      if (index > 0) {
        let item = this.iteminfo.config.datalist[index - 1]
        this.iteminfo.config.datalist.splice(index - 1, 1)
        this.iteminfo.config.datalist.splice(index, 0, item)
      }
    },
    onDownClick (index) {
      if (index < (this.iteminfo.config.datalist.length - 1)) {
        let item = this.iteminfo.config.datalist[index + 1]
        this.iteminfo.config.datalist.splice(index + 1, 1)
        this.iteminfo.config.datalist.splice(index, 0, item)
      }
    },
    onDelClick (index) {
      this.iteminfo.config.datalist.splice(index, 1)
    },
    getUpColor (index) {
      if (index === 0) {
        return '#BBBBBB'
      } else {
        return '#666666'
      }
    },
    getDownColor (index, length) {
      if (length === 0 || index === length - 1) {
        return '#BBBBBB'
      } else {
        return '#666666'
      }
    },

    choicePic () {
      this.$refs.picChoiceWidget.show()
    },

    picChoiceOk (data) {
      if (data && data.length) {
        let pic = data[0]
        this.iteminfo.config.btBgImg = pic.url
        // this.clickItem2ShowPicModal.title = pic.title
        // this.clickItem2ShowPicModal.width = pic.width
        // this.clickItem2ShowPicModal.height = pic.height
      }
    },

    getBgImgWidth(){
      if (this.iteminfo.config.isFloat ===3){
        return ''
      }
      return '100%'
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-setting ::v-deep {

  .ivu-modal-body {
    padding: 0;
    display: flex;
    justify-content: center;
    align-content: center;
  }

  //标题下横线
  .ivu-modal-header {
    border-bottom: none;
  }

  //确认取消按钮上面红线
  .ivu-modal-footer {
    border-top: none;
  }
}

.list-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: flex-start;
  flex-wrap: wrap;
  overflow-x: hidden;
}

.item {
  width: 140px;
  height: 170px;
  flex-direction: row;
  margin-bottom: 10px;
}

.item-selected {
  //border-color: #0EA4FB;
  //border-width: 2px;
  border: 2px solid #0EA4FB;
}

.item-normal {
  //border-color: #0EA4FB;
  //border-width: 2px;
  border: 2px solid white;
}

.item-editable {
  display: none;
}

.item:hover .item-editable {
  display: flex;
}

.lin2 {
  color: #333;
  max-width: 600px;
  font-size: 13px;
  line-height: 20px;
  //height: 40px;
  //margin-top: 6px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
  -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
  -webkit-line-clamp: 2; /** 显示的行数 **/
  overflow: hidden; /** 隐藏超出的内容 **/
}


.triangle {
  width: 0;
  height: 0;
  border-color: transparent #0F8CFB;
  border-width: 0 25px 25px 0;
  border-style: solid;
}
</style>
